import { NOTIFICATIONS_CLEARED_AT_PREFIX } from './api/api-functions';
import { Component, Suspense, lazy } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { initGA, initTag } from './utilities/google-tools';

import { Auth } from './pages/Login/Auth';
import Authorized from './utilities/authorization-route';
import { FallbackLoading } from './components/Loading';
import Logout from './pages/authentication/logout';
import { NotistackDispatcher } from './components/NotistackDispatcher';
import RegistrationWithLink from './pages/RegistrationWithLink/RegistrationWithLink';
import { connect } from 'react-redux';
import Webview from './pages/Webview';
import EditorWebview from './pages/EditorWebview';
import version from '../package.json';
const ForgotPassword = lazy(() =>
  import('./pages/ForgotPassword/ForgotPassword')
);
const Register = lazy(() => import('./pages/Register'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const Layout = lazy(() => import('./pages/Layout'));
const Welcome = lazy(() => import('./pages/welcome'));
const Processing = lazy(() => import('./pages/Processing'));

initGA()
initTag(process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID)

class App extends Component {
  componentDidMount() {
    this.checkVersionAndClearCache();
  }

  checkVersionAndClearCache = () => {
    const currentVersion = process.env.REACT_APP_VERSION || version.version;
    const savedVersion = localStorage.getItem("app_deploy_version");

    if (savedVersion && savedVersion !== currentVersion) {
      console.warn(`New version detected: ${currentVersion}. Clearing cache...`);

      const preservedMarkers = Object.keys(localStorage)
        .filter((key) => key.startsWith(NOTIFICATIONS_CLEARED_AT_PREFIX))
        .map((key) => [key, localStorage.getItem(key)]);

      localStorage.clear();
      sessionStorage.clear();

      preservedMarkers.forEach(([key, value]) => {
        if (value != null) localStorage.setItem(key, value);
      });

      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => caches.delete(name));
        });
      }

      localStorage.setItem('app_deploy_version', currentVersion);

      window.location.reload();
    } else {
      localStorage.setItem('app_deploy_version', currentVersion);
    }
  }
  render() {
    let role = this.props.user.loggedUser.role
      ? this.props.user.loggedUser.role
      : 'Anonymus';
    return (
      <Router>
        <NotistackDispatcher>
          <Suspense fallback={FallbackLoading}>
            <Switch>
              <Route
                path="/RegisterWithLink"
                component={Authorized(role)(['Anonymus'])(RegistrationWithLink)(
                  '/'
                )}
              />
              <Route
                path="/Welcome"
                component={Authorized(role)(['Anonymus'])(Welcome)(
                  '/'
                )}
              />
              <Route
                path="/Processing"
                component={Authorized(role)(['Anonymus', 'Admin', 'Assistant', 'Client', 'Guest', 'AdminClient'])(Processing)('/Login')}
              />
              <Route path="/Login/:logout?" component={Auth}></Route>
              <Route path="/webview" component={Webview}></Route>
              <Route path="/editor" component={EditorWebview}></Route>
              <Route path="/Logout/:autoLogout" component={Logout} />
              <Route
                path="/ForgotPassword"
                component={Authorized(role)(['Anonymus'])(ForgotPassword)('/')}
              />
              <Route
                path="/ResetPassword"
                component={Authorized(role)(['Anonymus'])(ResetPassword)('/')}
              ></Route>
              <Route path="/Logout/:autoLogout" component={Logout}></Route>
              <Route
                path="/Register"
                component={Authorized(role)(['Anonymus'])(Register)('/')}
              />
              <Route
                path="/"
                component={Authorized(role)([
                  'Admin',
                  'Assistant',
                  'Client',
                  'Guest',
                  'AdminClient',
                ])(Layout)('/Login')}
              />
            </Switch>
          </Suspense>
        </NotistackDispatcher>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(App);
